// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.person-manager {
  max-width: 1200px;
  margin: 0 auto;
  animation: slideIn 0.3s ease;
}

.person-manager h2 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.add-person-section {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.add-person-section h3 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #00ff88;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #ccc;
}

.form-group input {
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-group input:focus {
  outline: none;
  border-color: rgba(0, 255, 136, 0.5);
  background: rgba(255, 255, 255, 0.08);
}

.form-group input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.add-button {
  width: 100%;
  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);
  border: none;
  color: #0a0a0a;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1.2rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.add-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 40px rgba(0, 255, 136, 0.4);
}

.add-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: linear-gradient(135deg, #444 0%, #555 100%);
  color: #999;
}

.existing-persons {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 2rem;
}

.existing-persons h3 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #00ff88;
}

.no-persons {
  text-align: center;
  padding: 2rem;
  color: #888;
}

.no-persons p {
  margin-bottom: 1rem;
  font-size: 1.1rem;
}

.persons-table {
  width: 100%;
  overflow-x: auto;
}

.table-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1.2fr 1.2fr 1fr 100px;
  gap: 1rem;
  padding: 1rem;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  font-size: 0.9rem;
}

.table-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1.2fr 1.2fr 1fr 100px;
  gap: 1rem;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  align-items: center;
  transition: all 0.3s ease;
}

.table-row:hover {
  background: rgba(0, 255, 136, 0.05);
}

.person-name {
  font-weight: 500;
  color: white;
}

.money-spent {
  color: #ffaa00;
  font-weight: 500;
}

.savings.positive {
  color: #00ff88;
  font-weight: 500;
}

.savings.negative {
  color: #ff4444;
  font-weight: 500;
}

.created-date {
  color: #888;
  font-size: 0.9rem;
}

.actions {
  display: flex;
  justify-content: center;
  align-items: center;
}

.delete-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
}

.delete-button,
.confirm-delete-button,
.cancel-delete-button {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.4rem 0.6rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.delete-button {
  background: rgba(255, 68, 68, 0.2);
  border-color: rgba(255, 68, 68, 0.4);
}

.delete-button:hover:not(:disabled) {
  background: rgba(255, 68, 68, 0.3);
  border-color: rgba(255, 68, 68, 0.6);
}

.confirm-delete-button {
  background: rgba(255, 68, 68, 0.3);
  border-color: rgba(255, 68, 68, 0.5);
}

.confirm-delete-button:hover:not(:disabled) {
  background: rgba(255, 68, 68, 0.4);
  border-color: rgba(255, 68, 68, 0.7);
}

.cancel-delete-button {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
}

.cancel-delete-button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
}

.delete-confirmation {
  font-size: 0.8rem;
  color: #ff4444;
  white-space: nowrap;
  margin-right: 0.5rem;
}

.delete-button:disabled,
.confirm-delete-button:disabled,
.cancel-delete-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.message {
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-weight: 500;
}

.message.success {
  background: rgba(0, 255, 136, 0.1);
  border: 1px solid rgba(0, 255, 136, 0.3);
  color: #00ff88;
}

.message.error {
  background: rgba(255, 68, 68, 0.1);
  border: 1px solid rgba(255, 68, 68, 0.3);
  color: #ff4444;
}

@media (max-width: 768px) {
  .table-header,
  .table-row {
    grid-template-columns: 2fr 0.8fr 1fr 1fr 0.8fr 80px;
    font-size: 0.9rem;
  }
  
  .table-header {
    font-size: 0.8rem;
  }
  
  .delete-actions {
    gap: 0.3rem;
  }
  
  .delete-button,
  .confirm-delete-button,
  .cancel-delete-button {
    padding: 0.3rem 0.4rem;
    font-size: 0.8rem;
  }
  
  .delete-confirmation {
    font-size: 0.7rem;
  }
}

@media (max-width: 480px) {
  .table-header,
  .table-row {
    grid-template-columns: 2fr 0.8fr 1fr 1fr 60px;
    font-size: 0.8rem;
  }
  
  .created-date {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PersonManager.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iGAAiG;EACjG,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,0CAA0C;EAC1C,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uDAAuD;EACvD,WAAW;AACb;;AAEA;EACE,iGAAiG;EACjG,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,aAAa;EACb,iDAAiD;EACjD,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,aAAa;EACb,kDAAkD;EAClD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE;;IAEE,mDAAmD;IACnD,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE,6CAA6C;IAC7C,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".person-manager {\n  max-width: 1200px;\n  margin: 0 auto;\n  animation: slideIn 0.3s ease;\n}\n\n.person-manager h2 {\n  font-size: 2.5rem;\n  margin-bottom: 2rem;\n  text-align: center;\n  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.add-person-section {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.add-person-section h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  color: #00ff88;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #ccc;\n}\n\n.form-group input {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: white;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: rgba(0, 255, 136, 0.5);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.form-group input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.add-button {\n  width: 100%;\n  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);\n  border: none;\n  color: #0a0a0a;\n  padding: 1rem 2rem;\n  border-radius: 12px;\n  font-size: 1.2rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n}\n\n.add-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 40px rgba(0, 255, 136, 0.4);\n}\n\n.add-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: linear-gradient(135deg, #444 0%, #555 100%);\n  color: #999;\n}\n\n.existing-persons {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 2rem;\n}\n\n.existing-persons h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  color: #00ff88;\n}\n\n.no-persons {\n  text-align: center;\n  padding: 2rem;\n  color: #888;\n}\n\n.no-persons p {\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n}\n\n.persons-table {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.table-header {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1.2fr 1.2fr 1fr 100px;\n  gap: 1rem;\n  padding: 1rem;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  font-weight: 600;\n  color: #888;\n  text-transform: uppercase;\n  font-size: 0.9rem;\n}\n\n.table-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1.2fr 1.2fr 1fr 100px;\n  gap: 1rem;\n  padding: 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.table-row:hover {\n  background: rgba(0, 255, 136, 0.05);\n}\n\n.person-name {\n  font-weight: 500;\n  color: white;\n}\n\n.money-spent {\n  color: #ffaa00;\n  font-weight: 500;\n}\n\n.savings.positive {\n  color: #00ff88;\n  font-weight: 500;\n}\n\n.savings.negative {\n  color: #ff4444;\n  font-weight: 500;\n}\n\n.created-date {\n  color: #888;\n  font-size: 0.9rem;\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.delete-actions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.delete-button,\n.confirm-delete-button,\n.cancel-delete-button {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 0.4rem 0.6rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.delete-button {\n  background: rgba(255, 68, 68, 0.2);\n  border-color: rgba(255, 68, 68, 0.4);\n}\n\n.delete-button:hover:not(:disabled) {\n  background: rgba(255, 68, 68, 0.3);\n  border-color: rgba(255, 68, 68, 0.6);\n}\n\n.confirm-delete-button {\n  background: rgba(255, 68, 68, 0.3);\n  border-color: rgba(255, 68, 68, 0.5);\n}\n\n.confirm-delete-button:hover:not(:disabled) {\n  background: rgba(255, 68, 68, 0.4);\n  border-color: rgba(255, 68, 68, 0.7);\n}\n\n.cancel-delete-button {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.cancel-delete-button:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.delete-confirmation {\n  font-size: 0.8rem;\n  color: #ff4444;\n  white-space: nowrap;\n  margin-right: 0.5rem;\n}\n\n.delete-button:disabled,\n.confirm-delete-button:disabled,\n.cancel-delete-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.message {\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  font-weight: 500;\n}\n\n.message.success {\n  background: rgba(0, 255, 136, 0.1);\n  border: 1px solid rgba(0, 255, 136, 0.3);\n  color: #00ff88;\n}\n\n.message.error {\n  background: rgba(255, 68, 68, 0.1);\n  border: 1px solid rgba(255, 68, 68, 0.3);\n  color: #ff4444;\n}\n\n@media (max-width: 768px) {\n  .table-header,\n  .table-row {\n    grid-template-columns: 2fr 0.8fr 1fr 1fr 0.8fr 80px;\n    font-size: 0.9rem;\n  }\n  \n  .table-header {\n    font-size: 0.8rem;\n  }\n  \n  .delete-actions {\n    gap: 0.3rem;\n  }\n  \n  .delete-button,\n  .confirm-delete-button,\n  .cancel-delete-button {\n    padding: 0.3rem 0.4rem;\n    font-size: 0.8rem;\n  }\n  \n  .delete-confirmation {\n    font-size: 0.7rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .table-header,\n  .table-row {\n    grid-template-columns: 2fr 0.8fr 1fr 1fr 60px;\n    font-size: 0.8rem;\n  }\n  \n  .created-date {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
